import script from "./FormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormView.vue?vue&type=script&setup=true&lang=ts"

import "./FormView.vue?vue&type=style&index=0&id=65e5059c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e5059c"]])

export default __exports__